import React from "react";
import { usHttp2 } from "../custom-hooks/use-http";
import appvariables from "../appvariables";
import Button from "../components/Button";
import { useDispatch } from "react-redux";
import { loadingsliceactions } from "../store/loading-slice";
import { notificationsliceactions } from "../store/notification";
import Dropdown from "../components/Dropdown";

const Calculations = () => {
    const masterdispatcher = useDispatch();
    const [range, setRange] = React.useState("");

    const handleRangeChange = (e) => {
        setRange(e.target.value);
    }

    const calculateProfitforBills = () => {
        masterdispatcher(loadingsliceactions.updateloading({'state': 'loading'}));
        let time1 = new Date();

        usHttp2(appvariables.apiurl+'bill/calculateprofitforbills/', 'POST', {"range": range})
        .then((response) => response.json())
        .then((json) => 
        {
            let time2 = new Date();
            let diff = Math.ceil((time2.getTime() - time1.getTime())/1000);
            masterdispatcher(loadingsliceactions.updateloading({'state': ''}));
            if(json.status === "Success")
            {
            masterdispatcher(notificationsliceactions.updatenotification({'message': 'Profit for all bills calculated in '+ diff +' seconds', 'status': json.status}));
            }
            else
            {
                masterdispatcher(notificationsliceactions.updatenotification({'message': json.message, 'status': json.status}));
            }
        })
    }

    const calculatectr = () => {
        masterdispatcher(loadingsliceactions.updateloading({'state': 'loading'}));
        let time1 = new Date();

        usHttp2(appvariables.apiurl+'stock/calculatectrforall/', 'POST', {})
        .then((response) => response.json())
        .then((json) => 
        {
            let time2 = new Date();
            let diff = Math.ceil((time2.getTime() - time1.getTime())/1000);
            masterdispatcher(loadingsliceactions.updateloading({'state': ''}));
            if(json.status === "Success")
            {
                masterdispatcher(notificationsliceactions.updatenotification({'message': 'CTR for all stocks calculated in '+ diff +' seconds', 'status': json.status}));
            }
            else
            {
                masterdispatcher(notificationsliceactions.updatenotification({'message': json.message, 'status': json.status}));
            }
        })
    }

    return(
        <React.Fragment>
            <h2>Calculations</h2>
            <div style={{display: 'grid', gridTemplateRows: '1fr', gap: '20px'}} >
                <Dropdown
                    dropdownstyle={"compact"}
                    options={[
                        "Last 7 days",
                        "Last 14 days",
                        "Last 1 Month",
                        "Last 3 Months",
                        "Last 6 Months"
                    ]}
                    id={"calculation-range"}
                    name={"range"}
                    displayname={"Select Range"}
                    changehandler={handleRangeChange}
                    value={range}
                />
                <Button disabled={range === ""}
                cs={{
                  cursor: range === "" ? 'not-allowed' : 'pointer',
                  backgroundColor: range === "" && "rgba(0,0,0,0.6)",
                  borderColor: range === "" && "rgba(0,0,0,0.6)",
                }} clickhandler={calculateProfitforBills} >Calculate Profit for Bills</Button>
                <Button cs={{ cursor: 'pointer'}} clickhandler={calculatectr}>Calculate CTR</Button>
            </div>
        </React.Fragment>
    )
}

export default Calculations;